<template>
  <b-table
      :fields="fields"
      :items="items"
      @row-clicked="onClickRow"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @sort-changed="onSortChanged"
      table-class="text-nowrap"
      responsive
      hover
  >
    <template #cell(name)="data">
      <h4 class="mb-0">{{ data.item.name }}</h4>
    </template>
    <template #cell(status)="data">
      <admin-company-status-badge :company="data.item.company"/>
    </template>
    <template #cell(plan_start)="data">
      {{ convertFromUtc(data.item.company.pivot.starts_at, 'L') }}
    </template>
  </b-table>
</template>

<script>
import {convertFromUtc} from "../helpers";
import AdminCompanyStatusBadge from "./AdminCompanyStatusBadge";

export default {
  name: "AdminCompaniesTable",
  components: {AdminCompanyStatusBadge},
  props: {
    companies: {
      type: Array,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    pricingPlanView: {
      type: Boolean,
      default: false
    },
    sortBy: String,
    sortDesc: Boolean
  },
  data() {
    return {
      fields: this.getTableFields()
    }
  },
  computed: {
    items() {
      return this.companies.map(company => {
        return {
          company: company,
          name: company.name,
          tier_level: company.tier_level,
          date_added: convertFromUtc(company.created_at, 'L'),
          date_approved: company.approved_at ? convertFromUtc(company.approved_at, 'L') : ''
        }
      })
    }
  },
  methods: {
    convertFromUtc,
    onSortChanged(ctx) {
      this.$emit('sort-changed', ctx);
    },
    getTableFields() {
      let fields = [
        {
          key: "name",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "status",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "tier_level",
          thClass: "border-top-0 text-center",
          tdClass: "align-middle cursor-pointer text-center"
        },
        {
          key: "date_added",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer",
          sortable: true
        },
        {
          key: "date_approved",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
      ];

      if (this.small) {
        fields = [
          {
            key: "name",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "date_added",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
        ];
      }

      if (this.pricingPlanView) {
        fields = [
          {
            key: "name",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "plan_start",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
        ];
      }

      return fields;
    },
    onClickRow(item) {
      let companyId = item.company.id;
      this.$router.push({ name: "admin-company", params: { id: companyId.toString() } });
    }
  }
}
</script>
